import React from "react";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import { Drawer, Button, PageHeader } from "antd";
import { useState } from "react";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import { DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import TournamentEntry from "../../components/masters/tournament/TournamentEntry";
import TournamentList from "../../components/masters/tournament/TournamentList";
import { ALL_TOURNAMENT_XLS_URL } from "../../utility/URL";
import commonUtility from "../../utility/Utils";


const TournamentMaster = () => {
  const [visible, setVisible] = useState(false);
  const [tournamentAddData, settournamentAddData] = useState({
    tournament_id: 0,
    tournament_name: '',
    tournament_start_date: '',
    tournament_end_date: '',
    mode: "ADD"
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };


  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Tournament"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,

            <Button key="2" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_TOURNAMENT_XLS_URL)}>
              <FileExcelOutlined /> Excel
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add New Tournament"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon={<><DrawableCloseIcon /></>}
        >
          <TournamentEntry data={tournamentAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
          <div className="form-content">
            {/* <TimeSlotList /> */}
            <TournamentList />
          </div>
        </div>

      </div>
    </div>
  );
}
export default TournamentMaster;